/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabPanel, TabView } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";
// import Grn from "layouts/grn-details/grn";
// import GroupedGrn from "layouts/grn-details/grouped-grn";
import FinishedGoods from "./finished-goods";
import GroupedFinishedGoods from "./grouped-finished-goods";
import Sfg from "./sfg";

const cookies = new Cookies();

const FinishedGoodsParent = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let finishedGoodsModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "42bcba80-45bf-4528-9451-dc005bbfcf60",
  );

  let groupedFinishedGoodsModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "a393b70e-84b9-4632-9e0d-b4a20238fdac",
  );

  let semiFinishedGoodsModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "2c307360-74e0-4b3f-8bc1-1ed04b74fada",
  );
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {finishedGoodsModule &&
            groupedFinishedGoodsModule &&
            semiFinishedGoodsModule ? (
              <TabView>
                <TabPanel header="Finished Goods">
                  <FinishedGoods />
                </TabPanel>
                <TabPanel header="Grouped Finished Goods">
                  <GroupedFinishedGoods />
                </TabPanel>
                <TabPanel header="Semi Finished Goods">
                  <Sfg />
                </TabPanel>
              </TabView>
            ) : !finishedGoodsModule &&
              groupedFinishedGoodsModule &&
              semiFinishedGoodsModule ? (
              <TabView>
                <TabPanel header="Grouped Finished Goods">
                  <GroupedFinishedGoods />
                </TabPanel>
                <TabPanel header="Semi Finished Goods">
                  <Sfg />
                </TabPanel>
              </TabView>
            ) : finishedGoodsModule &&
              !groupedFinishedGoodsModule &&
              semiFinishedGoodsModule ? (
              <TabView>
                <TabPanel header="Finished Goods">
                  <FinishedGoods />
                </TabPanel>
                <TabPanel header="Semi Finished Goods">
                  <Sfg />
                </TabPanel>
              </TabView>
            ) : finishedGoodsModule &&
              groupedFinishedGoodsModule &&
              !semiFinishedGoodsModule ? (
              <TabView>
                <TabPanel header="Finished Goods">
                  <FinishedGoods />
                </TabPanel>
                <TabPanel header="Grouped Finished Goods">
                  <GroupedFinishedGoods />
                </TabPanel>
              </TabView>
            ) : !finishedGoodsModule &&
              !groupedFinishedGoodsModule &&
              semiFinishedGoodsModule ? (
              <TabView>
                <TabPanel header="Semi Finished Goods">
                  <Sfg />
                </TabPanel>
              </TabView>
            ) : finishedGoodsModule &&
              !groupedFinishedGoodsModule &&
              !semiFinishedGoodsModule ? (
              <TabView>
                <TabPanel header="Finished Goods">
                  <FinishedGoods />
                </TabPanel>
              </TabView>
            ) : !finishedGoodsModule &&
              groupedFinishedGoodsModule &&
              !semiFinishedGoodsModule ? (
              <TabView>
                <TabPanel header="Grouped Finished Goods">
                  <GroupedFinishedGoods />
                </TabPanel>
              </TabView>
            ) : (
              <>
                <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                  No Finished Goods Access
                </h4>
              </>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapStateToDispatch,
)(FinishedGoodsParent);
